import type { ExcalidrawElement } from "@excalidraw/excalidraw/element/types"
import type { AppState } from "@excalidraw/excalidraw/types"

export enum LldStages {
  TestInstructions = "test_instructions",
  InterviewSetup = "interview_setup",
  RequirementGathering = "requirement_gathering",
  ClarifyingRequirements = "clarifying_requirements",
  ClassDiagram = "class_diagram",
  SchemaDesign = "schema_design",
  Continuation = "continuation",
  Completed = "completed",
  Disqualification = "disqualification",
}

export interface ExcalidrawState {
  elements: readonly ExcalidrawElement[]
  appState: Partial<AppState>
}

export interface Comment {
  id: number
  nodeId: string
  author: "Bot" | "User"
  content: string
  created_at: number
  status: "resolved" | "unresolved"
  parent_comment_id: number | null
}
